import { getAllVisualAssetDefinitions } from '../../../visualAssets/catalog';
import { TERRAIN_BIOME_DEFINITIONS } from '../../../terrain/registry';
import type { AtlasSourceDescriptor } from './assetProvider';

function normalizeWorldDimension(value: number | undefined, fallback: number): number {
  return typeof value === 'number' && Number.isFinite(value) && value > 0 ? value : fallback;
}

export function getDefaultWorldAtlasSources(): AtlasSourceDescriptor[] {
  const terrainSources: AtlasSourceDescriptor[] = TERRAIN_BIOME_DEFINITIONS.map((definition) => ({
    id: definition.id,
    kind: 'terrain',
    sourcePath: definition.previewPath,
    drawWidth: 1,
    drawHeight: 1,
    pivotX: 0,
    pivotY: 0,
  }));

  const objectSources: AtlasSourceDescriptor[] = getAllVisualAssetDefinitions().map((definition) => ({
    id: definition.id,
    kind: 'object',
    sourcePath: definition.imagePath,
    sourceWidth: definition.width,
    sourceHeight: definition.height,
    drawWidth: normalizeWorldDimension(definition.width, 64) / 64,
    drawHeight: normalizeWorldDimension(definition.height, 64) / 64,
    pivotX: 0.5,
    pivotY: 1,
    offsetY: definition.yOffsetTiles,
    animated: definition.animated,
    animationGroupId: definition.animated ? definition.id : undefined,
    animationDurationMs: definition.animated ? 1000 : undefined,
  }));

  return [...terrainSources, ...objectSources];
}
